export const INVOICE_FORM_CONTAINER = 'invoice-form'
export const INVOICE_FORM_INLINE_QUERY = `@container ${INVOICE_FORM_CONTAINER} (min-width: 560px)`
